import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="footer">
      <span><Link to="/about" style={{color:"rgb(91, 112, 131)"}}>about us</Link></span>
      <span><Link to="/en/terms" style={{color:"rgb(91, 112, 131)"}}>terms</Link></span>
      <span><Link to="/support" style={{color:"rgb(91, 112, 131)"}}>support</Link></span>
      <span>© {new Date().getFullYear()} Studybud, Inc.</span>
    </div>
  );
};

export default Footer;
